import { categories } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

const iconMap: Record<string, string> = {
  news: "ri-flashlight-line",
  behind: "ri-folder-unknow-line",
  industry: "ri-line-chart-line",
  culture: "ri-message-3-line",
};

interface ColumnsProps {
  onPick?: (key: string) => void;
}

function Columns({ onPick }: ColumnsProps) {
  return (
    <section id="columns" className="relative border-y border-background-900 bg-background-900/40 py-16 md:py-24">
      <div className="container-x">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="栏目矩阵"
            title="四个入口，从不同角度吃瓜"
            desc="从热搜速览到行业深潜，挑一个方向，稳稳把你送到感兴趣的那一层。"
          />
          <a
            href="#featured"
            onClick={() => onPick?.("all")}
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-300 transition-colors hover:text-primary-200"
          >
            浏览全部文章
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.key}
              href="#featured"
              onClick={() => onPick?.(c.key)}
              data-category={c.key}
              className="group flex flex-col rounded-2xl border border-background-800 bg-background-950/60 p-6 transition-colors hover:border-accent-500/40 hover:bg-background-900"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-background-900 text-accent-400 transition-colors group-hover:bg-accent-500 group-hover:text-background-950">
                  <i className={`${iconMap[c.key] || "ri-compass-3-line"} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-serif text-2xl font-bold text-foreground-800 transition-colors group-hover:text-foreground-500">
                  {c.count}
                </span>
              </div>
              <h3 className="mt-6 font-serif text-xl font-bold text-foreground-50">{c.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">{c.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-foreground-400 transition-colors group-hover:text-accent-300">
                进入栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Columns;